import { Component, OnInit, ViewChild, inject } from '@angular/core';
import {ImageManager} from "../../../shared/image-manager";
import {ToastService} from "../../../services/toast/toast.service";
import {ToastTextType} from "../../../shared/object/toast";
import {LocationSwitchPopupComponent} from "../location-switch-popup/location-switch-popup.component";
import { ModalService } from 'src/app/services/modal.service';
import { LongPressDirective } from '../../../shared/directive/long-press.directive';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
    selector: 'app-page-tabbar',
    templateUrl: './page-tabbar.component.html',
    styleUrls: ['./page-tabbar.component.css'],
    imports: [RouterLink, RouterLinkActive, LongPressDirective]
})
export class PageTabbarComponent implements OnInit {

  longPressClicked = false;

  @ViewChild('switchPopupComponent') locationSwitchPopupComponent: LocationSwitchPopupComponent;

  private toastr: ToastService = inject(ToastService);
  private modalService: ModalService = inject(ModalService);


  ngOnInit(): void {
  }

  protected readonly ImageManager = ImageManager;

  onLongPress() {
    this.modalService.open();
  }
}
